import gql from 'graphql-tag'
import { PRODUCT_FRAGMENT } from './fragments.graphql'

export const GET_ACTIVITY_PRODUCTS = gql`
  ${PRODUCT_FRAGMENT}

  query GetActivityProducts($activityId: Int!) {
    activity(activityId: $activityId) {
      id
      productErpIdentifiers
      products {
        ...Product
        category {
          name
          englishPathSlug
        }
      }
    }
  }
`
